let cachedIp: string | null = null;

export const getClientIp = async (): Promise<string> => {
  if (cachedIp) return cachedIp;

  const localIp = localStorage.getItem("user_ip");
  if (localIp) {
    cachedIp = localIp;
    return cachedIp;
  }

  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    cachedIp = data.ip;
    localStorage.setItem("user_ip", cachedIp);
    return cachedIp;
  } catch (err) {
    console.error("Failed to fetch client IP:", err);
    return "";
  }
};
